import store from "../";
import { AUTH_USER_GET } from "Admin/legacy/store/modules/auth";
import _ from "lodash";

export const checkUserRolePermission = (roles = []) => {
  if (!roles.length) return false;
  const rawUserRoles = store.getters[AUTH_USER_GET].roles.map((role) => [
    role.name,
    role.parent_name,
  ]);
  const userRoles = rawUserRoles.flat();
  return roles.some((role) => userRoles.includes(role));
};
